import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import SubitemSidebar from '../../comum/components/SubitemSidebar';
import ItemSidebar from '../../comum/components/ItemSidebar'
import LogoMobile from '../../../assets/svg/logominSVG';
import { IconeMenu, IconeCarregar } from '../../comum/components/Icones';
import logoSalvador from '../../../assets/images/logo_salvador.png'
import logoRIG from '../../../assets/images/logo_riogrande.png'
import { buildTime, urlApi,clientVersion } from '../../../config/Constantes'
import lscache from 'lscache';
import { IconeGenerico } from "../components/Icones";
import {arrayIsEmpty} from "../../../utils/functions";
import ScrollBarArea from './ScrollBarArea';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import HomeService from '../../../services/HomeService';
import { ArtemisCaisUrl } from '../../../config/Constantes'

@inject("store")
@inject("routes")
@observer
export default class SideBar extends Component {

    constructor(props) {
        super(props);
        this.store = this.props.store;
        this.routes = this.props.routes;
        this.loginStore = this.props.store.loginStore;
        this.appStore = this.props.store.appStore;
        this.ambiente = "";
        this.homeService = new HomeService();
        this.state = {
            atualiza : true
        }
    }

    componentDidMount() {
        this.loginStore.isLogado = true;
        this.loginStore.getUsuarioMenus();
        this.exibeAmbiente();
        const logado = lscache.get('access_token');
        if (process.env.ssa && logado && !this.loginStore.sideBarMontado)
        {
            this.atualizaMenu();
        } 
        try{
            this.homeService.GetApiVersion().then((result) =>{
                this.appStore.apiVersion = result.data.Version;
            }).catch(ex=>{
                console.log("error "+ex);
            })

        }catch(ex){
            console.log(ex);
        }
        
    }

    isMainLink(menuCategoryItens) {
        return Array.isArray(menuCategoryItens) && menuCategoryItens.map((el) => el.onSideBar).indexOf(true) === -1;
    }

    subItemSelected(itens) {
        return Array.isArray(itens) && itens.map((el) => el.path === this.appStore.currentPage).indexOf(true) !== -1;
    }

    chooseLogo(width) {
        if (process.env.rig) {
            return <img className="logo" src={logoRIG} width={width} />
        } else {
            return <img className="logo" src={logoSalvador} width={width} />
        }
    }

    escolheTerminal = () => {
        if (process.env.rig) return "RIG";
        else return "SSA";
    };


    validaAcesso = (opcao) => {
        let result = false;

        if (!arrayIsEmpty(this.loginStore.permissoes)) 
        {
            result = this.loginStore.permissoes.includes(opcao);
        }
        
       return result;
    }
    
    exibeAmbiente =()=> {
        if (urlApi.includes("hml"))
        {
            this.ambiente = "Base de Homologação";
        }
        if (urlApi.includes("dsv"))
        {
            this.ambiente = "Base de Desenvolvimento";
        }
    }

    atualizaMenu = () =>
    {        
        this.setState({atualiza: false});
        setTimeout(() => {
            this.setState({atualiza: true});
        }, 1000);
        
        this.loginStore.sideBarMontado = true;        
    }
    
    renderSideBarMenu = () => {
        let sideItens = [];
        const terminal = this.escolheTerminal();
        const myScrollbar = {
            height: window.innerHeight > 500 ? window.innerHeight-300 : 300
          };
        if (lscache.get('short_access_token')){
                sideItens.push(
                <ItemSidebar
                    label={'Janela de Atracação'} 
                    labelIcon={<div style={{fontSize: "15px"}}><IconeGenerico icone="anchor" tamanho="lg" className="icon"  /></div>}
                    sideItensGroup={[]}
                    appStore={this.appStore}
                    isLink={true}
                    goTo={ArtemisCaisUrl+"/login?token="+lscache.get('short_access_token')+"&refresh="+lscache.get('refresh_token')} 
                />
            )
        }
        for (let i = 0; i < this.routes.length; i++) {
            if (!this.routes[i].terminalVisibility || this.routes[i].terminalVisibility.indexOf(terminal) !== -1) {
                let menuCategory = this.routes[i];
                // Só continua se estiver logado ou se não precisa estar logado para mostrar o menu                
                if (lscache.get('access_token') || menuCategory.needLogin === false) {
                    const sideItensGroup = [];
                    let key = 0;
                    let menuAcesso = this.validaAcesso(menuCategory.tag); // Verifica se está na lista de permissões do usuário
                    if (menuAcesso || menuCategory.needLogin === false) {
                        if (typeof menuCategory.itens !== 'undefined') {
                            for (let j = 0; j < menuCategory.itens.length; j++) {
                                const menuCategoryItem = menuCategory.itens[j];
                                if (!menuCategoryItem.terminalVisibility || menuCategoryItem.terminalVisibility.indexOf(terminal) !== -1) {
                                    let menuItem = this.validaAcesso(menuCategoryItem.tag); // Verifica se está na lista de permissões do usuário
                                    if (menuItem || menuCategoryItem.needLogin === false) {
                                        if (menuCategoryItem.onSideBar) {
                                            const space = <span className="space" />
                                            const listCount = menuCategoryItem.listCount ? <span
                                                className={this.store.appStore.sidebarFechado ? "inbox-count minimized" : "inbox-count"}>{menuCategoryItem.listCount}</span> : "";
                                            const item = <SubitemSidebar
                                                title={menuCategoryItem.label}
                                                key={`subItem#${key}`}
                                                to={menuCategoryItem.path}
                                            >
                                                {space}{listCount}
                                                <span
                                                    className={this.store.appStore.sidebarFechado ? "sidebar-label" : "sidebar-label"}>
                                                    {menuCategoryItem.label}
                                                </span>
                                            </SubitemSidebar>
                                            sideItensGroup.push(item);
                                            key++;
                                        }
                                    }
                                }
                            }
                        }
                        const labelIcon = menuCategory.icon ? menuCategory.icon : "";
                        
                        sideItens.push(
                            <ItemSidebar 
                                label={menuCategory.label}
                                labelIcon={labelIcon}
                                sideItensGroup={sideItensGroup}
                                appStore={this.appStore}
                                selected={this.subItemSelected(menuCategory.itens) || (this.appStore.currentPage === (menuCategory.itens) ? menuCategory.itens[0].path : '')}
                                isLink={this.isMainLink(menuCategory.itens)}
                                goTo={(menuCategory.itens) ? menuCategory.itens[0].path : '/'}
                            />
                        );
                    }
                }

            }
        }

        sideItens.push(
                <ItemSidebar
                    label={'Portal de Atendimento'}
                    labelIcon={<div style={{fontSize: "15px"}}><IconeGenerico icone="headset" tamanho="lg" className="icon" /></div>}
                    sideItensGroup={[]}
                    appStore={this.appStore}
                    isLink={true}
                    goTo={process.env.rig ? "http://atendimento.teconline.com.br/" : "http://atendimento.teconsvonline.com.br/"} 
                />
        )

        sideItens.push(
            <ItemSidebar
                label={'Contato via Whatsapp'} 
                labelIcon={<div style={{fontSize: "15px"}}><FontAwesomeIcon icon={faWhatsapp} size="lg" /></div>}
                sideItensGroup={[]}
                appStore={this.appStore}
                isLink={true}
                goTo={process.env.rig ? "https://api.whatsapp.com/send?phone=555332343030" : "https://api.whatsapp.com/send?phone=557121061500"} 
            />

        )

        if(process.env.ssa){
            sideItens.push(
                <ItemSidebar
                    label={'Política Integrada'} 
                    labelIcon={<div style={{fontSize: "15px"}}><IconeGenerico icone="exclamation" tamanho="lg" className="icon"  /></div>}
                    sideItensGroup={[]}
                    appStore={this.appStore}
                    isLink={true}
                    goTo="https://drive.google.com/file/d/1Pxqet4ok42Iug8zYI0bK3xZH-hStZXT1/view?usp=sharing" 
                />    
            )
            sideItens.push(
                <ItemSidebar
                    label={'Certificados'} 
                    labelIcon={<div style={{fontSize: "15px"}}><IconeGenerico icone="book" tamanho="lg" className="icon"  /></div>}
                    sideItensGroup={[]}
                    appStore={this.appStore}
                    isLink={true}
                    goTo="https://drive.google.com/drive/folders/12MbK5DCLkY_c97WV9PkVR1MwHN-EHd35?usp=sharing" 
                />
            )
            
        }

        sideItens = sideItens.map((element, index) => (
                <div key={`item#${index}`} className="menu-category">
                    {element}
                </div>
            )
        );


        return (
            <div className={this.store.appStore.sidebarFechado ? "side-bar minimized" : "side-bar"}>
                <a onClick={() => this.appStore.toggleSideBar()} className={`menu-container`}>
                    <div className="collapse-sidebar-button"><IconeMenu tamanho="lg" /></div>
                </a>
                <div className={`side-bar--content ${this.store.appStore.sidebarFechado && "side-bar--content__closed"}`}>
                    {(!this.loginStore.usuarioLogado || !this.loginStore.usuarioLogado.matricula) && this.loginStore.loadingUsuarioLogado &&
                        <div className="sidebar-loader">
                            <IconeCarregar tamanho="2x" />
                        </div>
                    }
                    <div className="text-center-narrow mt-5 mb-4">
                        {this.store.appStore.sidebarFechado ? this.chooseLogo(44) : this.chooseLogo(110)}                        
                    </div>  
                    <div>
                        <ScrollBarArea style={myScrollbar}>
                            {sideItens}
                        </ScrollBarArea>
                        {!this.store.appStore.sidebarFechado &&
                        <div className="text-center-narrow mt-1">
                            <span className="label-informacoes-light"> Versão Cliente : {clientVersion}</span>
                        </div>}
                        {!this.store.appStore.sidebarFechado &&
                        <div className="text-center-narrow mt-1">
                            <span className="label-informacoes-light"> 
                            Versão API : {this.appStore.apiVersion}
                            </span>
                        </div>}
                        {!this.store.appStore.sidebarFechado &&
                        <div className="text-center-narrow mt-4">
                            <span className="label-informacoes-light"> &copy; 2024 - Wilsons Sons - {`${process.env.rig ? "Rio Grande" : "Salvador"}`}</span>
                        </div>}
                        {!this.store.appStore.sidebarFechado &&
                        <div className="text-center-narrow mt-1">
                            <span className="label-informacoes-light"> {`Atualizado em: ${buildTime}`}</span>
                        </div>}
                        {!this.store.appStore.sidebarFechado &&
                        <div className="text-center-narrow">
                            <span className="label-informacoes-light"> {this.ambiente}</span>
                        </div>}
                        {!this.store.appStore.sidebarFechado &&
                        <div className="text-center-narrow mt-1 mb-5">
                            <span className="label-informacoes-light"> </span>
                        </div>}
                    </div>
                </div>
                <div className="sidebar-shadow" onClick={() => this.appStore.toggleSideBar()}></div>
            </div>
        )
    }

    render() {
        return this.state.atualiza ? this.renderSideBarMenu() : <div />
    }
}



// WEBPACK FOOTER //
// ./src/modules/comum/components/SideBar.js